/**
 * Phase 18.16-B Batch 4 — /webshop PageBanner wrapper.
 *
 * Drop-in replacement for the static <PageBanner> in WebshopPage. Loads
 * eyebrow / title / highlight / subtitle + USP-badges + optional CTAs
 * from the CMS. The product grid, filters, cart, checkout dialog and
 * Stripe-redirect flow remain entirely code-driven and untouched.
 */
import React from "react";
import { ShoppingCart } from "lucide-react";
import useMiscPageCms from "../hooks/useMiscPageCms";
import { ToolPageBanner } from "./ToolPageCms";

const FALLBACK = {
  page_banner: {
    eyebrow: "5999Cargo Webshop",
    title: "Verhuisdozen &",
    highlight: "cargo materialen",
    subtitle:
      "Verhuisdozen, cargo benodigdheden en services voor uw zending naar Curaçao en het Caribisch gebied. Veilige betaling via Stripe.",
    badges: [
      { icon: "shield",  label: "Veilig betalen via Stripe" },
      { icon: "receipt", label: "BTW-inclusief prijzen" },
      { icon: "package", label: "Verhuisdozen + services" },
    ],
  },
  intro: {},
  cta_band: {},
};

export default function WebshopPageBanner() {
  const { data } = useMiscPageCms("webshop", FALLBACK);
  return (
    <ToolPageBanner
      banner={data?.page_banner || FALLBACK.page_banner}
      image="https://images.unsplash.com/photo-1573552991725-c7b115591d04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
      imageAlt="5999Cargo webshop — verhuisdozen en cargo materialen"
      eyebrowIcon={ShoppingCart}
      testid="webshop-banner"
    />
  );
}
